export default __webpack_public_path__ + "static/media/css.61575168.bin";